import axios from 'axios';
import { API_BASE_URL } from '../../config/apiConfig';

const get = async (url, params, fallback) => {
    try {
        const r = await axios.get(`${API_BASE_URL}${url}`, { params });
        return r.data;
    } catch (error) {
        if (error.response?.data) throw error.response.data;
        throw error.message || fallback;
    }
};

const post = async (url, payload, fallback) => {
    try {
        const r = await axios.post(`${API_BASE_URL}${url}`, payload);
        return r.data;
    } catch (error) {
        if (error.response?.data) throw error.response.data;
        throw error.message || fallback;
    }
};

const put = async (url, payload, fallback) => {
    try {
        const r = await axios.put(`${API_BASE_URL}${url}`, payload);
        return r.data;
    } catch (error) {
        if (error.response?.data) throw error.response.data;
        throw error.message || fallback;
    }
};

// ── Lookups ──────────────────────────────────────────────────────────────────

export const getNatureOfGroups = () => get('/Accounts/GetNatureofGroups', {}, 'Failed to fetch nature of groups');
export const getMasterGroupsByNature = (NatureGroupId) =>
    get('/Accounts/GetMasterGroupbsbyNature', { NatureGroupId }, 'Failed to fetch groups');
export const getSubGroupsByGroupId = (GroupId) =>
    get('/Accounts/GetAllSubGroupsbyGroupid', { GroupId }, 'Failed to fetch sub groups');
export const checkITCodeExist = (Itcode) => get('/Accounts/CheckITCodeExist', { Itcode }, 'Failed to check IT code');
export const getApprovalStatusIT = (CheckType, ROID) =>
    get('/Accounts/GetapprstatusIT', { CheckType, ROID }, 'Failed to fetch allowed actions');

// ── Grid ─────────────────────────────────────────────────────────────────────

export const getAllItCodeDetails = () => get('/Accounts/GetAllItCodeDetails', {}, 'Failed to fetch IT codes');

// ── Save / Edit / Delete ─────────────────────────────────────────────────────

export const saveITCode = (payload) => post('/Accounts/SaveITCode', payload, 'Failed to save IT code');
export const editITCode = (payload) => put('/Accounts/EditITCode', payload, 'Failed to update IT code');
